var map = {
	"./apartament.png": [
		1267,
		307
	],
	"./bed.png": [
		1268,
		308
	],
	"./boat.png": [
		1269,
		309
	],
	"./bungalow.png": [
		1270,
		310
	],
	"./camper.png": [
		1271,
		311
	],
	"./house.png": [
		1272,
		312
	],
	"./maisonette.png": [
		1273,
		313
	],
	"./room.png": [
		1274,
		314
	],
	"./smallhouse.png": [
		1275,
		315
	],
	"./studio.png": [
		1276,
		316
	],
	"./tent.png": [
		1277,
		317
	],
	"./villa.png": [
		1278,
		318
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1698;
module.exports = webpackAsyncContext;